const currency_code_options = [
  { label: "PLN", value: "PLN" },
  { label: "EUR", value: "EUR" },
  { label: "CZK", value: "CZK" },
];

export default currency_code_options;
